import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { CheckCircle2 } from "lucide-react";

const BEFORE = [
  "Install the Zoom app and sign in once before your first session",
  "Test your microphone, camera and internet connection",
  "Join 5 minutes early using the Join button on this portal",
  "Keep a notebook or doc open for your own notes",
  "Think of one work problem you understand; we'll use it in projects",
];

const FAQ = [
  ["How do I join a live session?", "Every session card has a Join button. It turns into a green \"Join now\" 15 minutes before the session starts. Click it to open Zoom directly."],
  ["I missed a session. What now?", "No problem. The recording link is added to the same session card after the class. Watch it, tick the checklist, and ask your questions in the next session."],
  ["Where are the slides, notes and checklists?", "Inside each session card. Slides, notes, videos and links open with one click; checklists can be ticked off and your progress is saved."],
  ["How do I submit my project?", "Go to the Projects tab, open the assignment and upload a file (PDF, ZIP, PPT up to 25 MB) and/or paste your GitHub link. You'll get an email when it's reviewed, and the feedback appears right here."],
  ["Can I resubmit after feedback?", "Yes. Submit again on the same assignment; all your attempts and feedback stay visible."],
  ["What data can I use in projects?", "Use synthetic, public or approved data only. Never upload confidential employer, client, customer or personal data."],
  ["Who do I contact for help?", "Reply to any email from ArtOfResume or write to rakesh@bharatreborn.com. We usually respond within one working day."],
];

export const StartHere = () => (
  <div className="grid gap-5 lg:grid-cols-[1fr_1.3fr]">
    <div data-testid="start-here-checklist" className="rounded-2xl bg-[#0B1B33] p-6 text-white">
      <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-teal-300">Before your first session</p>
      <ul className="mt-4 space-y-3">{BEFORE.map((b) => <li key={b} className="flex gap-2.5 text-[15px]"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-teal-300" />{b}</li>)}</ul>
    </div>
    <Accordion type="single" collapsible defaultValue="f0" className="rounded-2xl border border-slate-200 bg-white px-5">
      {FAQ.map(([q, a], i) => (
        <AccordionItem key={q} value={`f${i}`} className={i === FAQ.length - 1 ? "border-b-0" : ""}>
          <AccordionTrigger data-testid={`learn-faq-${i}`} className="font-display text-left text-[16px] font-semibold text-[#0B1B33] hover:no-underline">{q}</AccordionTrigger>
          <AccordionContent className="text-[15px] leading-relaxed text-slate-700">{a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </div>
);
